var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"account__form-wrap"},[_c('IgnoredIPAddresses'),_c('div',{staticClass:"account__form-section-wrap"},[_c('AccountKeys'),_c('URLHijackingProtection')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }